import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dded00f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactform-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "haveAQuestionForOurTeam" }, " Have a question for our team? "),
  /*#__PURE__*/_createElementVNode("div", { class: "sendUsAnEmail" }, "Send us an email")
], -1))
const _hoisted_3 = { class: "form-input-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label form-input-label",
  for: "name"
}, "Name", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "w-100 form-input-text",
  type: "email",
  name: "name",
  id: "name",
  placeholder: "First name and Last name",
  required: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label form-input-label",
  for: "email"
}, "Email address", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "w-100 form-input-text",
  type: "email",
  name: "email",
  id: "email",
  placeholder: "spotter@example.com",
  required: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label form-input-label",
  for: "phone"
}, "Phone no", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "w-100 form-input-text",
  type: "text",
  name: "phone",
  id: "phone",
  placeholder: "800-976-5678",
  required: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("textarea", {
  placeholder: "Type your message...",
  class: "w-100 form-input-textarea",
  name: "message",
  id: "message",
  required: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-input-note" }, " Your email will be responded to as soon as we can ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "form-input-button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-input-button-text" }, "Send Message")
], -1))

import { IonPage, IonGrid } from "@ionic/vue";
import StaticMenu from "@/landing/components/landing/StaticMenu.vue";
import LandingHeader from "@/landing/components/landing/LandingHeader.vue";
import LandingFooterStatic from "@/landing/components/landing/LandingFooterStatic.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StaticMenu),
    _createVNode(_unref(IonPage), {
      class: "contactus-page",
      id: "landing-page"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), { fixed: true }, {
          default: _withCtx(() => [
            _createVNode(LandingHeader)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonGrid), { fixed: true }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(LandingFooterStatic)
      ]),
      _: 1
    })
  ], 64))
}
}

})